/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.components.data')
    .factory('SamlResourceFactory', function ($resource: JS5Function, EndPointService: JS5Object) {
        return $resource(EndPointService.samlEndPoint, {},
            {
                isSamlEnabled: {
                    method: 'GET',
                    url: EndPointService.samlEndPoint,
                    params: {isSamlEnabled: true},
                    isArray: false,
                    transformResponse: (data: string) => {
                        return {
                            isSamlEnabled: `${data}` === 'true'
                        };
                    }
                }
            }
        );
    });
